module.exports = __webpack_public_path__ + "prod/1.42.2/img/msg1.2864385d.png";